import { useSelector } from 'react-redux';

import { hasPermission } from 'utils/permissions';

const getActionItems = (services, viewQueryDetails) => {
  const row = viewQueryDetails?.queryInstance;
  const id = row?.id;
  const currentEmployee = viewQueryDetails?.currentEmployee;
  return [
    {
      label: 'Escalate',
      onClick: () => services.escalateQueryNavigationService({ id }),
      icon: '',
      permissions: ['ROLE_BASE_PERMISSION_QUER_INDEX_ESCALATE_QUERY'],
    },
    {
      label: 'Delete',
      onClick: () => services.handleOpenDialog(true, { ...row }),
      icon: '',
      permissions: ['ROLE_BASE_PERMISSION_QUER_INDEX_DELETE_QUERY'],
      conditional: () =>
        row?.resolutionStatus?.toUpperCase() === 'DRAFT' || row?.resolutionStatus?.toUpperCase() === 'REOPENED',
    },
    {
      label: 'Submit',
      onClick: () => services.submitQueryService(id),
      icon: '',
      permissions: ['ROLE_BASE_PERMISSION_QUER_INDEX_SUBMIT_QUERY'],
      conditional: () =>
        row?.resolutionStatus?.toUpperCase() === 'DRAFT' || row?.resolutionStatus?.toUpperCase() === 'REOPENED',
    },
    {
      label: 'Action',
      onClick: () => services.actionQueryNavigationService({ id }),
      icon: '',
      permissions: ['ROLE_BASE_PERMISSION_QUER_INDEX_ACTION_QUERY'],
      conditional: () =>
        row?.resolutionStatus?.toUpperCase() === 'UNDER REVIEW' &&
        currentEmployee &&
        currentEmployee?.id === row?.currentOwner?.id,
    },
    {
      label: 'Revert',
      onClick: () => services.revertQueryService({ id }),
      icon: '',
      permissions: ['ROLE_BASE_PERMISSION_QUER_INDEX_REVERT_QUERY'],
      conditional: () =>
        row?.resolutionStatus?.toUpperCase() === 'UNDER REVIEW' &&
        currentEmployee &&
        currentEmployee?.id === row?.currentOwner?.id,
    },
    {
      label: 'Reassign',
      onClick: () => services.reassignQueryNavigationService({ id }),
      icon: '',
      permissions: ['ROLE_BASE_PERMISSION_QUER_INDEX_REASSIGN_QUERY'],
      conditional: () =>
        row?.resolutionStatus?.toUpperCase() === 'UNDER REVIEW' &&
        currentEmployee &&
        currentEmployee?.id === row?.currentOwner?.id,
    },
    {
      label: 'Recall',
      onClick: () => services.recallQueryService({ id }),
      icon: '',
      permissions: ['ROLE_BASE_PERMISSION_QUER_INDEX_RECALL_QUERY'],
      conditional: () =>
        row?.resolutionStatus?.toUpperCase() === 'UNDER REVIEW' &&
        currentEmployee &&
        currentEmployee?.id === row?.openedBy?.id,
    },
    {
      label: 'Reopen',
      onClick: () => services.reopenQueryNavigationService({ id }),
      icon: '',
      permissions: ['ROLE_BASE_PERMISSION_QUER_INDEX_REOPEN_QUERY'],
      conditional: () =>
        [
          'Closed - Resolved',
          'Closed - Unresolved',
          'Closed - Duplicate',
          'Closed - Rejected',
          'Closed - Incorrect',
        ].includes(row?.resolutionStatus) &&
        currentEmployee &&
        currentEmployee?.id === row?.openedBy?.id,
    },
  ];
};

const useMenuItems = (services) => {
  const authorities = useSelector((state) => state.session.user.authorities);
  const { viewQueryDetails = {} } = useSelector((state) => state?.queries);

  const actions = getActionItems(services, viewQueryDetails);

  const moreFilteredActionItems = actions.filter((action) => {
    const userHasPermission = hasPermission(authorities, action.permissions);
    if ((action.conditional && !action.conditional(services.state.queryDetails?.reportDetails)) || !userHasPermission) {
      return false;
    }
    return true;
  });

  return [moreFilteredActionItems];
};

export default useMenuItems;
